import { AuthenticationService } from "../services/authentication.service";



const { fetch: originalFetch } = window;

const authenticationService = new AuthenticationService();



const HttpInterceptor = () => {
	
	window.fetch = async (...args) => {
	
		let [resource, config ] = args;
		
		if (authenticationService.isUserLogged()) {
			const authentication = authenticationService.getAuthenticationSession();
			
			config.headers['Authorization'] = 'Bearer ' + authentication.token.access_token;
		}
			
		const response = await originalFetch(resource, config);
		
		if (response.status === 401) {
	      // Handle the 401 error (e.g., redirect to login, display error)
	      //console.error("Unauthorized! Redirecting to login...");
	      authenticationService.setAuthenticationSession(null);
	      window.location.href = '/not-auth';  // Redirect to not authorized page
	      return;
		}
		return response;
    }
    
    
}

export default HttpInterceptor;